// Lib
import React from 'react';

// Components
import FdmButton from '../Card/FdmButton';

// Hooks
import useProductDetailsQtyButtons from '../../../hooks/useProductDetailsQtyButtons';

// Styles
import { useStyles } from './ProductDetailsButtonsStyles';

const ProductDetailsButtons = ({
  product,
  isMobileMode,
  cartProps,
  detailsMode = false,
  hideQtyButtons = false,
}) => {
  const { classes } = useStyles();
  const { productQtyButtons } = useProductDetailsQtyButtons(
    product,
    cartProps,
    isMobileMode,
    detailsMode,
  );

  return (
    <div className={classes.buttonsContainer}>
      {!hideQtyButtons && productQtyButtons}
      {!isMobileMode && (
        <FdmButton className={classes.fdmButton} product={product} />
      )}
    </div>
  );
};

export default ProductDetailsButtons;
